import { getProductMessages } from '@/components/modules/products/messages/productMessages'
import { formatUiMessage } from '@/components/shared/utils/uiMessages'

const DEFAULT_LABELS = {
  expandTable: '展开表格',
  collapseTable: '收起表格',
  tableN: '表格{n}',
  viewingHotspot: '正在查看标点 {n} · 点击图片空白处返回总览',
  hotspotHintDefault: '点击图中数字标点，可查看对应说明'
}

let currentLabels = { ...DEFAULT_LABELS }

/** 按站点语言刷新富文本表格/热点交互文案 */
export function syncRichContentUiLabels(localeCode) {
  const product = getProductMessages(localeCode)
  currentLabels = {
    expandTable: product.expandTable || DEFAULT_LABELS.expandTable,
    collapseTable: product.collapseTable || DEFAULT_LABELS.collapseTable,
    tableN: product.tableN || DEFAULT_LABELS.tableN,
    viewingHotspot: product.viewingHotspot || DEFAULT_LABELS.viewingHotspot,
    hotspotHintDefault: product.hotspotHintDefault || DEFAULT_LABELS.hotspotHintDefault
  }
  return currentLabels
}

export function getRichContentUiLabels() {
  return currentLabels
}

export function formatTableN(index) {
  return formatUiMessage(currentLabels.tableN, { n: index + 1 })
}

export function formatViewingHotspot(index) {
  if (index < 0) return currentLabels.hotspotHintDefault
  return formatUiMessage(currentLabels.viewingHotspot, { n: index + 1 })
}
